import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PayRatePage = () => {
  const columns = [
    { key: 'discipline', label: 'Discipline' },
    { key: 'visitType', label: 'Visit Type' },
    { key: 'rate', label: 'Rate' },
    { key: 'rateType', label: 'Rate Type' },
    { key: 'effectiveDate', label: 'Effective Date' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'discipline', label: 'Discipline', type: 'select', required: true, options: [
      { value: 'RN', label: 'Registered Nurse' },
      { value: 'LPN', label: 'Licensed Practical Nurse' },
      { value: 'PT', label: 'Physical Therapist' },
      { value: 'PTA', label: 'Physical Therapist Assistant' },
      { value: 'OT', label: 'Occupational Therapist' },
      { value: 'COTA', label: 'Certified OT Assistant' },
      { value: 'SLP', label: 'Speech Language Pathologist' },
      { value: 'MSW', label: 'Medical Social Worker' },
      { value: 'HHA', label: 'Home Health Aide' },
    ]},
    { key: 'visitType', label: 'Visit Type', type: 'select', required: true, options: [
      { value: 'SOC', label: 'Start of Care' },
      { value: 'Routine', label: 'Routine Visit' },
      { value: 'ROC', label: 'Resumption of Care' },
      { value: 'Recert', label: 'Recertification' },
      { value: 'Discharge', label: 'Discharge' },
      { value: 'Hourly', label: 'Hourly Rate' },
    ]},
    { key: 'rate', label: 'Rate ($)', type: 'text', required: true },
    { key: 'rateType', label: 'Rate Type', type: 'select', required: true, options: [
      { value: 'Per Visit', label: 'Per Visit' },
      { value: 'Hourly', label: 'Hourly' },
      { value: 'Salary', label: 'Salary' },
    ]},
    { key: 'effectiveDate', label: 'Effective Date', type: 'date', required: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', discipline: 'RN', visitType: 'SOC', rate: '$85.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '2', discipline: 'RN', visitType: 'Routine', rate: '$65.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '3', discipline: 'PT', visitType: 'SOC', rate: '$95.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '4', discipline: 'PT', visitType: 'Routine', rate: '$75.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '5', discipline: 'OT', visitType: 'SOC', rate: '$90.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '6', discipline: 'OT', visitType: 'Routine', rate: '$70.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '7', discipline: 'SLP', visitType: 'SOC', rate: '$90.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '8', discipline: 'HHA', visitType: 'Routine', rate: '$18.00', rateType: 'Hourly', effectiveDate: '01/01/2024', active: 'Yes' },
    { id: '9', discipline: 'MSW', visitType: 'Routine', rate: '$60.00', rateType: 'Per Visit', effectiveDate: '01/01/2024', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Pay Rate"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Rate"
      formFields={formFields}
      apiEndpoint="/setup/pay-rate"
    />
  );
};

export default PayRatePage;
